import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { hideAddFormResults } from 'actions';

import ModalWrapper from 'components/Modals/ModalWrapper';
import { UploadPdfForm } from './UploadPdfForm';

class AddFormModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    isShown: PropTypes.bool.isRequired,
    parentForm: PropTypes.shape(),
    addImyLayer: PropTypes.bool,
    isAddingForm: PropTypes.bool,
    onConfirmUpload: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    addingFormResults: PropTypes.shape({
      error: PropTypes.shape({
        code: PropTypes.number,
        message: PropTypes.string,
      }),
      success: PropTypes.bool,
      files: PropTypes.arrayOf(PropTypes.shape({}))
    })
  };

  static defaultProps = {
    permissions: null,
    parentForm: null,
    addImyLayer: false,
    isAddingForm: false,
    addingFormResults: null
  };

  constructor() {
    super();
    this.state = { disableConfirmButton: true, isCreateNewCustomerCRSFormChecked: false, isCreateNewCustomerWFormChecked: false };
    this.setDisableConfirm = this.setDisableConfirm.bind(this);
    this.disableConfirm = this.disableConfirm.bind(this);
  }

  onCloseModal(e) {
    const { onCancel } = this.props;

    this.setState({
      isCreateNewCustomerWFormChecked: false,
      isCreateNewCustomerCRSFormChecked: false
    });

    if (onCancel) {
      onCancel(e);
    }
  }

  getParentCustomerName() {
    const { parentForm } = this.props;
    if (parentForm.customerName) {
      return parentForm.customerName;
    }
    return parentForm.name ? parentForm.name : '';
  }

  setDisableConfirm(val) {
    this.setState({ disableConfirmButton: val });
  }

  toggleCreateNewCustomerWForm = () => {
    const { isCreateNewCustomerWFormChecked } = this.state;
    this.setState({ isCreateNewCustomerWFormChecked: !isCreateNewCustomerWFormChecked });
  }

  toggleCreateNewCustomerCRSForm = () => {
    const { isCreateNewCustomerCRSFormChecked } = this.state;
    this.setState({ isCreateNewCustomerCRSFormChecked: !isCreateNewCustomerCRSFormChecked });
  }

  disableConfirm() {
    if (this.state) {
      const { disableConfirmButton } = this.state;
      return disableConfirmButton;
    }
    return true;
  }

  hideResults() {
    const { dispatch } = this.props;
    dispatch(hideAddFormResults());
  }

  render() {
    const {
      isShown,
      isAddingForm,
      parentForm,
      addImyLayer,
      onConfirmUpload,
      addingFormResults,
      permissions
    } = this.props;
    const {
      isCreateNewCustomerWFormChecked,
      isCreateNewCustomerCRSFormChecked
    } = this.state;
    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title={ parentForm ? `Add beneficiary form(s) to ${ this.getParentCustomerName() }` : 'Add form(s)' }
        btnConfirmTitle="Submit"
        btnConfirmClass={ `btn-primary ${ isAddingForm ? 'loading' : '' }` }
        btnCancelTitle="Close"
        onCancel={ e => this.onCloseModal(e) }
        disableConfirm={ this.disableConfirm }
        formId="uploadingPdfForm"
      >
        <UploadPdfForm
          id="uploadingPdfForm"
          onSubmit={ onConfirmUpload }
          permissions={ permissions }
          parentForm={ parentForm }
          addImyLayer={ addImyLayer }
          results={ addingFormResults }
          isSubmitting={ isAddingForm }
          setDisableConfirm={ val => this.setDisableConfirm(val) }
          toggleCreateNewCustomerCRSForm={ () => this.toggleCreateNewCustomerCRSForm() }
          toggleCreateNewCustomerWForm={ () => this.toggleCreateNewCustomerWForm() }
          isCreateNewCustomerWFormChecked={ isCreateNewCustomerWFormChecked }
          isCreateNewCustomerCRSFormChecked={ isCreateNewCustomerCRSFormChecked }
        />
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    auth: {
      permissions
    },
    forms: {
      isAddingForm,
      parentForm,
      addImyLayer,
      addingFormResults
    }
  } = state;
  return {
    permissions,
    parentForm,
    addImyLayer,
    isAddingForm,
    addingFormResults
  };
};

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddFormModal);
